export class ActionDescriptor {
  public actionType: string;
  public payload: any;
}

export class ActionTypes {
  public static ChangeSettlement = 'CHANGE-SETTLEMENT';
  public static LoadInvoiceableBooks = 'LOAD-INVOICEABLE-BOOKS';
}
